export default __webpack_public_path__ + "static/Entenda0078-fea800e588619e9cbe61df9e6a54d908.jpg";